import moment from 'moment';

import { XlsxSheet } from './xlsx';
import { PhoneValidation } from './phone-validation';

/**
 * Campurile care se pot exporta din lista de utilizatori. Ordinea de aici e
 * ordinea coloanelor din fisier, indiferent de ordinea in care au fost bifate.
 */
export interface UserExportField {
    key: string;
    label: string;
    width: number;
    value: (user: any) => string | number;
}

function text(value: any): string {
    return value == undefined ? '' : String(value).trim();
}

export const USER_EXPORT_FIELDS: UserExportField[] = [
    {
        key: 'paddle',
        label: 'Nr. licitare',
        width: 14,
        value: (user) => (typeof user.paddle === 'number' ? user.paddle : ''),
    },
    {
        key: 'firstName',
        label: 'Prenume',
        width: 20,
        value: (user) => text(user.firstName),
    },
    {
        key: 'lastName',
        label: 'Nume',
        width: 20,
        value: (user) => text(user.lastName),
    },
    {
        key: 'email',
        label: 'Email',
        width: 32,
        value: (user) => text(user.email),
    },
    {
        key: 'phone',
        label: 'Telefon',
        width: 18,
        // Text, ca sa pastreze 0 si + din fata. Un "telefon" cu @ e un email
        // completat in campul gresit, deci nu e un numar de telefon.
        // Conturile noi au prefixul separat; il punem in fata ("+40 753018255")
        value: (user) => {
            const phone = text(PhoneValidation.format(user));
            return phone.indexOf('@') === -1 ? phone : '';
        },
    },
    {
        key: 'address',
        label: 'Adresă',
        width: 45,
        value: (user) => {
            const address = user.address || {};
            return [address.street, address.city, address.county, address.country]
                .map(text)
                .filter(Boolean)
                .join(', ');
        },
    },
    {
        key: 'createdAt',
        label: 'Data înregistrării',
        width: 18,
        value: (user) =>
            user.createdAt ? moment(user.createdAt).format('DD.MM.YYYY') : '',
    },
    {
        key: 'verified',
        label: 'Verificat',
        width: 10,
        value: (user) => (user.verified ? 'Da' : 'Nu'),
    },
];

export const DEFAULT_USER_EXPORT_FIELDS = [
    'paddle',
    'firstName',
    'lastName',
    'email',
    'phone',
];

/**
 * O foaie cu coloanele alese. Randurile fara nicio valoare (ex. un user fara
 * telefon cand se exporta doar telefonul) se sar, iar randurile identice
 * (ex. acelasi email pe doua conturi) apar o singura data.
 */
export function buildUsersSheet(users: any[], fieldKeys: string[]): XlsxSheet {
    const fields = USER_EXPORT_FIELDS.filter(
        (field) => fieldKeys.indexOf(field.key) !== -1,
    );

    const sheet: XlsxSheet = {
        name: 'Utilizatori',
        freezeRows: 1,
        columns: fields.map((field) => ({ width: field.width })),
        rows: [
            fields.map((field) => ({
                value: field.label,
                variant: 'header' as 'header',
            })),
        ],
    };

    const seen: { [row: string]: boolean } = {};

    for (const user of users) {
        const row = fields.map((field) => field.value(user));

        if (row.every((value) => value === '')) {
            continue;
        }

        const rowKey = JSON.stringify(row).toLowerCase();
        if (seen[rowKey]) {
            continue;
        }
        seen[rowKey] = true;

        sheet.rows.push(row);
    }

    return sheet;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/users-export.ts